import React from 'react';
import { Link } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/24/solid';

const PaymentCancel = () => {
  return (
    <div className="container-custom py-16 text-center">
      <XCircleIcon className="h-24 w-24 text-red-500 mx-auto mb-4" />
      <h1 className="text-3xl font-bold mb-2">Payment Cancelled</h1>
      <p className="text-gray-600 mb-6">
        Your payment was cancelled. No charges have been made.
      </p>
      
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 max-w-md mx-auto">
        <p className="text-yellow-800">
          You can try again or contact support if you need assistance.
        </p>
      </div>
      
      <div className="flex gap-4 justify-center">
        <Link to="/cart" className="btn-primary">
          Return to Cart
        </Link>
        <Link to="/products" className="btn-secondary">
          Continue Shopping
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;